import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from "@nu-art/permissions-shared";
export const PermissionDomainName_FHIRManager = 'FHIR Manager';
export const PermissionKeys_FHIRManager = generateKeyNamesByAccessLevel(PermissionDomainName_FHIRManager, defaultUIAccessLevels);
//# sourceMappingURL=ui.js.map